import React, { useEffect, useRef, useState } from 'react';
import PortalTooltip from '../../PortalTooltip/PortalTooltip';
import './MeetingTileTitle.scss';

export interface MeetingTileTitleProps {
    title: string;
    tooltipKey: string | number;
}

export const MeetingTileTitle = (props: MeetingTileTitleProps) => {
    const titleRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const element = titleRef.current;
        if (element) {
            setIsTruncated(element.scrollWidth > element.clientWidth);
        }
    }, [props.title]);

    const anchorId = `meeting-tile-title-${props.tooltipKey}`;

    return (
        <div id={anchorId} ref={titleRef} className="meeting-tile-title">
            {props.title}
            {isTruncated && (
                <PortalTooltip
                    anchorId={anchorId}
                    delayShow={200}
                    place="top"
                    content={props.title}
                />
            )}
        </div>
    );
};
